import React, { AriaRole } from 'react';
import { useSelector } from 'react-redux';
import { IconAppBackgroundOutline, IconAppBackgroundFill } from '@saucelabs/ds-icons';

import { CONFIGURATION_TEST_TYPES } from '../../../constants';
import selectors from '../selectors';
import GenericPopover from './GenericPopover';
import GenericButton from './GenericButton';
import ButtonInstallApp from './ButtonInstallApp';
import ButtonSwitchAppVersion from './ButtonSwitchAppVersion';

const ApplicationButton: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const {
    deviceToolsDisabled,
    testType,
  } = useSelector(selectors.toolbarButtonSelector);

  return (
    <GenericPopover
      trigger={(
        <GenericButton
          dataQa="live-session-toolbar-application-group-button"
          disabled={deviceToolsDisabled}
          hasSubmenu
          icon={IconAppBackgroundOutline}
          iconHightlight={IconAppBackgroundFill}
          isPopoverTrigger
          label="Application"
          role={role || 'menuitem'}
        />
      )}
    >
      <>
        {(testType === CONFIGURATION_TEST_TYPES.APP) && (
          <>
            <ButtonInstallApp role="menuitem" />
            <ButtonSwitchAppVersion role="menuitem" />
          </>
        )}
      </>
    </GenericPopover>
  );
};

ApplicationButton.displayName = 'ApplicationButton';

export default ApplicationButton;
